/* ==========================================================================
   Cobijo — scripts propios (vanilla JS, sin librerías externas)
   ========================================================================== */

(function () {
  'use strict';

  // "Arma tu pack" (ver extensions/arma-pack-tope, el proyecto aparte
  // de la función de descuento) necesita saber en qué momento llegó
  // CADA UNIDAD al carrito — no solo cada producto — para que el tope
  // de 4 unidades respete siempre las primeras que llegaron, sea del
  // producto que sea, y deje fuera las últimas. Shopify no ofrece ese
  // dato, así que lo lleva el propio carrito: cada línea guarda una
  // propiedad oculta ("_mt_orden", con guion bajo para que el tema no
  // la muestre al cliente) con la lista de números de orden de CADA
  // una de sus unidades, separados por comas — por ejemplo, una línea
  // con 3 unidades podría tener "_mt_orden": "2,5,9" si esas 3
  // unidades llegaron en esos 3 momentos distintos (por ejemplo, 1
  // unidad al añadir el producto por primera vez, y 2 más añadidas
  // más tarde, con otros productos por en medio).
  //
  // NO se toca para nada la petición original de "añadir al carrito"
  // ni la de "cambiar cantidad" — el aviso de "producto añadido", el
  // cajón del carrito, etc. siguen viendo exactamente la respuesta de
  // siempre, así que no hay ningún riesgo de romperlos. En vez de eso,
  // justo DESPUÉS de que cualquier cambio en el carrito termine bien,
  // se revisa el carrito entero y se corrige (con una llamada aparte,
  // de fondo) la marca de cualquier línea que se haya quedado
  // desactualizada — le falten números (se añadieron unidades) o le
  // sobren (se quitaron).

  function mtOrdenTextoALista(texto) {
    if (!texto) return [];
    return String(texto)
      .split(',')
      .map(function (t) { return parseInt(t, 10); })
      .filter(function (n) { return !isNaN(n) && n > 0; });
  }

  function mtSiguienteNumeroOrdenGlobal() {
    var CLAVE = 'mt_orden_pack_contador';
    var actual = 0;
    try { actual = parseInt(localStorage.getItem(CLAVE) || '0', 10) || 0; } catch (e) { /* sin localStorage, se sigue desde 0 cada vez */ }
    actual += 1;
    try { localStorage.setItem(CLAVE, String(actual)); } catch (e) { /* no pasa nada, es solo una mejora de precisión */ }
    return actual;
  }

  var mtReconciliandoOrdenPack = false;
  var mtOrdenPackPendienteDeNuevo = false;

  // Cola global: TODA petición que modifica el carrito (añadir/cambiar,
  // tanto la del "regalo automático" como la de esta reconciliación)
  // pasa por aquí, una detrás de otra, nunca a la vez. Se comprobó con
  // un caso real que mandar dos peticiones de escritura al carrito casi
  // en el mismo instante (por ejemplo: "arreglar la marca de orden de
  // la línea del Arnés" a la vez que "añadir el regalo") podía acabar
  // en un resultado incorrecto — como que la cantidad de una línea se
  // quedara mal — aunque cada petición por separado llevara los datos
  // correctos; el problema era la propia carrera entre ellas, no los
  // datos. Poniéndolas en fila, una a una, esa carrera desaparece.
  var mtColaMutacionesCarrito = Promise.resolve();
  function mtEncolarMutacionCarrito(tarea) {
    var resultado = mtColaMutacionesCarrito.then(tarea, tarea);
    mtColaMutacionesCarrito = resultado.catch(function () {});
    return resultado;
  }

  // "keepalive: true" en todas las peticiones de aquí abajo: sin esto,
  // si el navegador cambia de página a mitad de la corrección (algo
  // frecuente — muchas altas redirigen a /cart nada más terminar), el
  // navegador cancela las peticiones que aún estén en el aire. Con
  // "keepalive" se dejan terminar igual, aunque la página ya se haya
  // ido — pensado justo para este caso (igual que los avisos de
  // analítica que se mandan al cerrar una pestaña).

  // HISTORIAL — por qué YA NO se fusionan las líneas del mismo producto:
  //
  // Antes había aquí una función que, al ver dos líneas separadas del
  // MISMO producto (mismo "variant_id"), las fusionaba en una sola vía
  // "/cart/change.js" (poniendo una a cantidad 0 y sumando su cantidad
  // en la otra). La idea era arreglar el caso de volver a añadir un
  // producto ya puesto en el carrito desde su ficha, que a veces creaba
  // una línea aparte en vez de sumar cantidad.
  //
  // Se comprobó (Ronda 133, con pruebas aisladas directamente contra
  // Shopify, sin este script de por medio) que esa fusión era la CAUSA
  // de un fallo mucho peor: cuando el descuento "Arma tu pack" (nuestra
  // función de descuento propia, ver extensions/arma-pack-tope) reparte
  // su porcentaje entre varias unidades del MISMO producto y el reparto
  // no cae en céntimos exactos (por ejemplo 2,29€ × 5% entre 2 unidades
  // = 1,14€ + 1,15€, no 1,145€ + 1,145€), Shopify representa esas dos
  // unidades como DOS LÍNEAS SEPARADAS en el carrito — cada una con su
  // descuento exacto — aunque sean el mismo producto y ni el cliente ni
  // nuestro propio código hayan hecho nada raro. Es un comportamiento
  // normal y esperado de Shopify con este tipo de descuento, no un
  // fallo.
  //
  // La fusión, al no saber distinguir ese caso de un duplicado de
  // verdad, intentaba juntar esas dos líneas en una — y Shopify, en la
  // siguiente vuelta, las volvía a separar por el mismo motivo del
  // descuento, entrando en un tira y afloja fusión↔separación. En algún
  // punto de ese vaivén, la cantidad total se podía quedar mal (por
  // ejemplo, dos unidades de compra reales acababan mostrando solo una
  // en el carrito) — el fallo real que reportó el cliente.
  //
  // Por eso ahora cada línea se deja tal cual la deja Shopify — puede
  // que a veces se vean dos filas para el mismo producto (con un
  // céntimo de diferencia de precio entre ellas), pero la cantidad y el
  // precio total SIEMPRE son correctos, y es lo que de verdad importa.
  // Lo único que se sigue arreglando por línea es la marca "_mt_orden"
  // (ver mtArreglarMarcaLinea, aquí abajo), que nunca toca la cantidad
  // de la línea — solo añade o quita números de la lista, así que no
  // puede perder ninguna unidad.

  // Arregla la marca "_mt_orden" de una línea cuya cantidad de números
  // no coincide con su cantidad de unidades (le faltan porque se
  // añadieron unidades, o le sobran porque se quitaron).
  //
  // OJO — todo el "leer + decidir + escribir" va metido dentro de UNA
  // sola tarea de la cola de mutaciones (mtEncolarMutacionCarrito): así
  // se relee el carrito bien fresco justo antes de escribir, ya con
  // cualquier otra escritura anterior (por ejemplo, el regalo
  // añadiéndose solo) ya terminada de verdad — no una lectura de antes
  // de esperar turno en la cola, que podría haberse quedado vieja.
  function mtArreglarMarcaLinea(fetchOriginal, clave) {
    return mtEncolarMutacionCarrito(function () {
      return fetchOriginal('/cart.js', { keepalive: true })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var item = cart.items.filter(function (i) { return i.key === clave; })[0];
          if (!item) return false; // la línea ya no existe, no hay nada que arreglar
          var marcas = mtOrdenTextoALista(item.properties && item.properties['_mt_orden']);
          if (marcas.length === item.quantity) return false; // ya está bien
          if (marcas.length < item.quantity) {
            var faltan = item.quantity - marcas.length;
            for (var i = 0; i < faltan; i++) marcas.push(mtSiguienteNumeroOrdenGlobal());
          } else {
            marcas = marcas.slice().sort(function (a, b) { return a - b; }).slice(0, item.quantity);
          }
          // Por "key" (fijo), no por posición — la posición puede quedar
          // desactualizada si esto coincide con otra alta al carrito casi
          // a la vez. Se manda SIEMPRE la misma "quantity" que se acaba
          // de leer para esta línea — nunca se cambia, así que esta
          // llamada no puede perder ni sumar ninguna unidad, solo pone al
          // día la lista de marcas.
          var propiedadesNuevas = {};
          Object.keys(item.properties || {}).forEach(function (k) { propiedadesNuevas[k] = item.properties[k]; });
          propiedadesNuevas['_mt_orden'] = marcas.join(',');
          return fetchOriginal('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: propiedadesNuevas }),
            keepalive: true,
          }).then(function () { return true; });
        });
    })
    .catch(function () { return false; });
  }

  function mtReconciliarOrdenPack(fetchOriginal) {
    if (mtReconciliandoOrdenPack) { mtOrdenPackPendienteDeNuevo = true; return; }
    mtReconciliandoOrdenPack = true;

    fetchOriginal('/cart.js', { keepalive: true })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var clavesAArreglar = cart.items
          .filter(function (item) {
            if (item.properties && item.properties['_mt_regalo']) return false; // el regalo no necesita marca
            var marcas = mtOrdenTextoALista(item.properties && item.properties['_mt_orden']);
            return marcas.length !== item.quantity;
          })
          .map(function (item) { return item.key; });

        if (clavesAArreglar.length === 0) return false;

        // Una detrás de otra (no a la vez), releyendo el carrito
        // antes de cada una por si algo más cambió mientras tanto.
        return clavesAArreglar.reduce(function (cadena, clave) {
          return cadena.then(function (huboCambioAntes) {
            return mtArreglarMarcaLinea(fetchOriginal, clave).then(function (huboCambio) { return huboCambioAntes || huboCambio; });
          });
        }, Promise.resolve(false));
      })
      .then(function (huboAlgunCambio) {
        mtReconciliandoOrdenPack = false;
        if (!huboAlgunCambio) {
          // Carrito estable (nada que arreglar) — se olvida cualquier
          // cuenta de recargas seguidas de antes, ver nota de
          // mtIntentosRecargaAgotados() más abajo.
          try { sessionStorage.removeItem('mt_orden_pack_intentos_recarga'); } catch (e) {}
        }
        if (huboAlgunCambio) {
          if (/\/cart\/?$/.test(window.location.pathname)) {
            // En /cart se recarga directamente — la propia carga de la
            // página vuelve a llamar a esta función, así que no hace
            // falta encadenar otra vuelta a mano (y la página está a
            // punto de irse de todos modos).
            //
            // OJO — antes de recargar, se espera a que la cola de
            // escrituras al carrito (mtEncolarMutacionCarrito) esté
            // vacía del todo. Se comprobó un caso real en el que la
            // recarga saltaba justo mientras el regalo automático
            // todavía tenía SU PROPIA alta al carrito en el aire (ver
            // initRegaloAutomatico) — la página nueva, al cargar, volvía
            // a comprobar el carrito, no veía el regalo todavía (porque
            // esa alta no había terminado de verdad) y lo añadía POR
            // SEGUNDA VEZ, quedando un "Mordedor" de más cobrado a
            // precio completo. Esperando aquí a que la cola esté
            // realmente vacía, la recarga solo ocurre cuando ya no
            // queda ninguna escritura pendiente de nadie.
            mtColaMutacionesCarrito.then(avisarCambioCarritoOrden, avisarCambioCarritoOrden);
            return;
          }
          // Fuera de /cart no hay recarga — puede que quede más por
          // hacer, así que se repite a mano.
          mtReconciliarOrdenPack(fetchOriginal);
        } else if (mtOrdenPackPendienteDeNuevo) {
          mtOrdenPackPendienteDeNuevo = false;
          mtReconciliarOrdenPack(fetchOriginal);
        }
      })
      .catch(function () {
        mtReconciliandoOrdenPack = false;
      });
  }

  // Ronda 148: freno de seguridad contra un bucle de recargas sin fin.
  //
  // Se comprobó un caso real: al subir la cantidad del Arnés varias
  // veces seguidas y rápido (el botón "+" del carrito), Shopify separa
  // las unidades en líneas distintas por el motivo de siempre (el
  // reparto del descuento "Arma tu pack" entre unidades del mismo
  // producto, ver el historial más arriba) — pero aquí, al escribir la
  // marca "_mt_orden" arreglada de una línea, ESE MISMO cambio puede
  // hacer que Shopify recalcule el descuento y vuelva a repartir las
  // líneas de otra forma, dejando la marca que se ACABA de arreglar
  // "desactualizada" otra vez de inmediato — y como esto pasa en
  // /cart, cada arreglo dispara una recarga, que vuelve a encontrar
  // algo por arreglar, que vuelve a recargar... sin parar nunca. La
  // cantidad y el precio del carrito en sí siempre quedan bien (eso no
  // lo toca esta marca) — lo que se queda mal es solo el orden interno
  // de desempate del tope de 4 unidades, algo mucho más leve que dejar
  // la página atascada "cargando" para siempre.
  //
  // Con este freno: como mucho UNA recarga por cada vez que hace falta
  // — si con esa no basta para que el carrito quede estable, se deja
  // de insistir (el carrito sigue siendo correcto en cantidad y
  // precio, solo puede quedar sin perfeccionar del todo esa marca
  // interna).
  //
  // OJO — arreglo posterior al primero: la cuenta guardada en
  // sessionStorage dura toda la sesión del navegador, así que sin más
  // control se quedaba "gastada" para siempre en cuanto saltaba una
  // vez — la vez siguiente que de verdad hacía falta recargar (por
  // ejemplo, al aplicar un código de descuento como BRUMA, que también
  // puede desactualizar estas marcas) el freno la bloqueaba igual,
  // aunque no tuviera nada que ver con el caso original, dejando el
  // descuento aplicado de verdad pero sin verse hasta que el cliente
  // recargaba la página a mano. Arreglado llevando también la hora de
  // la última vez: si ha pasado tiempo de sobra desde entonces
  // (`MT_VENTANA_RECARGAS_MS`), se entiende que es una situación nueva
  // y se vuelve a permitir una recarga, aunque la cuenta de la vez
  // anterior no se hubiera "gastado del todo" por sí sola.
  var MT_MAX_RECARGAS_ORDEN_SEGUIDAS = 1;
  var MT_VENTANA_RECARGAS_MS = 8000;
  function mtIntentosRecargaAgotados() {
    var clave = 'mt_orden_pack_intentos_recarga';
    var estado = { c: 0, t: 0 };
    try {
      var guardado = JSON.parse(sessionStorage.getItem(clave) || 'null');
      if (guardado && typeof guardado.c === 'number' && typeof guardado.t === 'number') estado = guardado;
    } catch (e) {}

    var ahora = Date.now();
    if (ahora - estado.t > MT_VENTANA_RECARGAS_MS) estado = { c: 0, t: 0 };

    if (estado.c >= MT_MAX_RECARGAS_ORDEN_SEGUIDAS) return true;
    try { sessionStorage.setItem(clave, JSON.stringify({ c: estado.c + 1, t: ahora })); } catch (e) {}
    return false;
  }

  function avisarCambioCarritoOrden() {
    // Mismo motivo que en el regalo automático (ver más abajo,
    // avisarCambioCarrito): el resumen de descuentos de la página del
    // carrito no siempre se refresca solo por AJAX cuando el cambio no
    // lo inicia la propia página — así que, si el cliente está viendo
    // /cart en este momento, se recarga para que el descuento
    // corregido se vea de verdad.
    if (!/\/cart\/?$/.test(window.location.pathname)) return;
    if (mtIntentosRecargaAgotados()) return;
    window.location.reload();
  }

  function initOrdenPackInterceptorFetch() {
    if (!window.fetch || window.fetch.__mtOrdenPackParcheado) return;
    var fetchOriginal = window.fetch.bind(window);
    var nuevoFetch = function (recurso, opciones) {
      var promesa = fetchOriginal(recurso, opciones);
      try {
        var url = typeof recurso === 'string' ? recurso : (recurso && recurso.url) || '';
        var esMutacionCarrito = /\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url);
        if (esMutacionCarrito) {
          // Sin "setTimeout": se lanza YA, sin esperar ni un instante —
          // se comprobó que muchas altas desde la ficha de producto
          // redirigen a /cart nada más terminar, y esa redirección
          // puede matar código pendiente de la página anterior antes
          // de que le toque el turno. Aun así, como red de seguridad
          // final, la comprobación se repite también al cargar
          // cualquier página nueva (ver la llamada de abajo) — así que
          // si esta vez no le da tiempo a terminar, se corrige sola en
          // cuanto cargue la siguiente página (normalmente /cart).
          promesa
            .then(function (respuesta) {
              if (respuesta && respuesta.ok) mtReconciliarOrdenPack(fetchOriginal);
            })
            .catch(function () {});
        }
      } catch (e) { /* si algo falla al vigilar, no afecta a la petición real */ }
      return promesa;
    };
    nuevoFetch.__mtOrdenPackParcheado = true;
    window.fetch = nuevoFetch;
    // Red de seguridad: al cargar CUALQUIER página (incluida /cart justo
    // después de que una alta redirija hasta aquí), se revisa también
    // por si algo se quedó a medias en la página anterior.
    mtReconciliarOrdenPack(fetchOriginal);
  }
  initOrdenPackInterceptorFetch();

  // Mismas traducciones que snippets/mt-traducir.liquid, para actualizar
  // textos en pantalla sin recargar la página (p. ej. al elegir un color).
  var MT_TRADUCCIONES = {
    'Color': 'Color',
    'Size': 'Talla',
    'Red': 'Rojo',
    'Ocean camouflage': 'Camuflaje océano',
    'Pink camouflage': 'Camuflaje rosa',
    'Green camouflage': 'Camuflaje verde',
    'Desert camouflage': 'Camuflaje desierto',
    'Leaves': 'Hojas'
  };
  function mtTraducir(texto) {
    return MT_TRADUCCIONES.hasOwnProperty(texto) ? MT_TRADUCCIONES[texto] : texto;
  }

  function initReveal() {
    var items = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      // Sin soporte: el CSS ya los deja visibles por defecto, no hace falta nada.
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var el = entry.target;
            var delay = el.getAttribute('data-mt-delay') || 0;
            setTimeout(function () { el.classList.add('mt-visible'); }, Number(delay));
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );
    items.forEach(function (el) {
      // Solo se "arma" (se oculta a la espera del scroll) si el JS llega hasta aquí.
      el.classList.add('mt-armed');
      observer.observe(el);
    });
  }

  function initProductoGaleria() {
    var wraps = document.querySelectorAll('[data-mt-galeria-producto]');
    wraps.forEach(function (wrap) {
      var principal = wrap.querySelector('[data-mt-imagen-principal]');
      var dataEl = wrap.querySelector('[data-mt-fotos-color]');
      var flechaAnt = wrap.querySelector('[data-mt-foto-anterior]');
      var flechaSig = wrap.querySelector('[data-mt-foto-siguiente]');
      var puntos = wrap.querySelector('[data-mt-puntos]');
      var minis = wrap.querySelectorAll('[data-mt-mini-color]');
      if (!principal || !dataEl) return;

      var fotosPorColor = {};
      try { fotosPorColor = JSON.parse(dataEl.textContent) || {}; } catch (e) { fotosPorColor = {}; }

      // El nombre real de la opción "de color" lo decide Liquid (puede
      // llamarse "Color", "Diseño", o lo que sea según el idioma/producto
      // — ver mt-producto.liquid) y viaja aquí en un atributo, para no
      // tener que suponer que siempre se llama literalmente "Color".
      var nombreOpcionColor = wrap.getAttribute('data-mt-nombre-opcion-color') || 'Color';
      var selectorOpcionColor = '[data-mt-opcion="' + CSS.escape(nombreOpcionColor) + '"]';

      var colorActivo = (wrap.parentElement && wrap.parentElement.querySelector(selectorOpcionColor + ' .is-active'))
        ? wrap.parentElement.querySelector(selectorOpcionColor + ' .is-active').getAttribute('data-mt-pill')
        : Object.keys(fotosPorColor)[0];
      var indiceActivo = 0;

      function fotosActuales() {
        return (fotosPorColor[colorActivo] && fotosPorColor[colorActivo].length) ? fotosPorColor[colorActivo] : [principal.src];
      }

      // Fila de miniaturas GENÉRICA (por foto, no por color): se crea a mano
      // solo cuando Liquid avisa (data-mt-tiene-miniaturas-color="false")
      // de que NO ha pintado ya su propia fila de miniaturas por color
      // (productos sin opción "Color", o con una sola foto por variante) y
      // hay más de una foto real que mostrar — así también se pueden ver
      // todas las fotos con un clic, igual que en el resto de fichas.
      // OJO: se mira ese aviso de Liquid, no si `minis` está vacío — mirar
      // solo el DOM aquí era frágil (con opción Color de verdad, esta fila
      // no debe crearse NUNCA, la ponga o no Liquid en ese momento).
      var teniaMiniaturasColor = wrap.getAttribute('data-mt-tiene-miniaturas-color') === 'true';
      var minisGenericas = null;
      if (!teniaMiniaturasColor && fotosActuales().length > 1) {
        minisGenericas = document.createElement('div');
        minisGenericas.className = 'mt-producto__miniaturas';
        fotosActuales().forEach(function (url, i) {
          var boton = document.createElement('button');
          boton.type = 'button';
          boton.className = 'mt-producto__mini';
          boton.setAttribute('data-mt-mini-foto', i);
          boton.setAttribute('aria-label', 'Ver foto ' + (i + 1));
          var img = document.createElement('img');
          img.src = url.replace('width=1400', 'width=200');
          img.loading = 'lazy';
          img.width = 200;
          img.height = 200;
          img.alt = '';
          boton.appendChild(img);
          boton.addEventListener('click', function () {
            indiceActivo = i;
            pintar();
          });
          minisGenericas.appendChild(boton);
        });
        principal.closest('.mt-producto__principal').insertAdjacentElement('afterend', minisGenericas);
      }

      function pintar() {
        var fotos = fotosActuales();
        if (indiceActivo >= fotos.length) indiceActivo = 0;
        principal.src = fotos[indiceActivo];

        var hayVarias = fotos.length > 1;
        if (flechaAnt) flechaAnt.style.display = hayVarias ? '' : 'none';
        if (flechaSig) flechaSig.style.display = hayVarias ? '' : 'none';

        if (puntos) {
          puntos.innerHTML = '';
          if (hayVarias) {
            fotos.forEach(function (_, i) {
              var punto = document.createElement('span');
              punto.className = 'mt-producto__punto' + (i === indiceActivo ? ' is-active' : '');
              puntos.appendChild(punto);
            });
          }
        }

        minis.forEach(function (m) {
          m.classList.toggle('is-active', m.getAttribute('data-mt-mini-color') === colorActivo);
        });

        if (minisGenericas) {
          minisGenericas.querySelectorAll('[data-mt-mini-foto]').forEach(function (m) {
            m.classList.toggle('is-active', parseInt(m.getAttribute('data-mt-mini-foto'), 10) === indiceActivo);
          });
        }
      }

      if (flechaAnt) flechaAnt.addEventListener('click', function () {
        var fotos = fotosActuales();
        indiceActivo = (indiceActivo - 1 + fotos.length) % fotos.length;
        pintar();
      });
      if (flechaSig) flechaSig.addEventListener('click', function () {
        var fotos = fotosActuales();
        indiceActivo = (indiceActivo + 1) % fotos.length;
        pintar();
      });

      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var color = mini.getAttribute('data-mt-mini-color');
          // Busca el "pill" del selector de color con este mismo valor y lo pulsa,
          // así se actualiza también el precio/variante/talla seleccionada.
          var pill = wrap.parentElement && wrap.parentElement.querySelector(selectorOpcionColor + ' [data-mt-pill="' + CSS.escape(color) + '"]');
          if (pill) { pill.click(); } else { colorActivo = color; indiceActivo = 0; pintar(); }
        });
      });

      document.addEventListener('mt:color-changed', function (e) {
        colorActivo = e.detail.color;
        indiceActivo = 0;
        pintar();
      });

      pintar();
    });
  }

  function initCantidad() {
    var wraps = document.querySelectorAll('[data-mt-cantidad]');
    wraps.forEach(function (wrap) {
      var input = wrap.querySelector('input');
      var menos = wrap.querySelector('[data-mt-menos]');
      var mas = wrap.querySelector('[data-mt-mas]');
      if (!input) return;
      function clamp(v) { return Math.max(1, Math.min(99, v)); }
      if (menos) menos.addEventListener('click', function () { input.value = clamp((parseInt(input.value, 10) || 1) - 1); });
      if (mas) mas.addEventListener('click', function () { input.value = clamp((parseInt(input.value, 10) || 1) + 1); });
      input.addEventListener('change', function () { input.value = clamp(parseInt(input.value, 10) || 1); });
    });
  }

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    var fmt = format || '{{amount}} €';
    // El formato real de Shopify puede ser {{amount}}, {{amount_with_comma_separator}}, etc.
    var resultado = fmt.replace(/\{\{\s*amount\w*\s*\}\}/, value);
    // A petición del usuario: el símbolo de la moneda va siempre DETRÁS
    // del número (28,99€), sea cual sea la moneda activa (€, $...) — si
    // el resultado empieza por el símbolo (no por un dígito, que es como
    // lo tiene configurado esta tienda de fábrica), se mueve al final.
    var conSimboloDelante = resultado.match(/^([^\d\s]+)\s*(.*)$/);
    if (conSimboloDelante) { resultado = conSimboloDelante[2] + conSimboloDelante[1]; }
    return resultado;
  }

  function initVariantes() {
    var forms = document.querySelectorAll('[data-mt-producto-form]');
    forms.forEach(function (form) {
      var dataEl = form.querySelector('[data-mt-variants-json]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      // Orden real de las opciones tal como las define el producto
      // (Liquid las vuelca en este orden al construir el JSON) — hace
      // falta para decidir qué pills "no disponibles" desactivar: una
      // opción solo se filtra por las que vienen ANTES que ella (p. ej.
      // la Talla se filtra por el Color ya elegido), nunca por las que
      // vienen después. Si se comprobara contra todas por igual, el
      // propio Color se podía quedar bloqueado por la Talla que hubiera
      // activa en ese momento, y no se podría cambiar de color nunca.
      var nombresOpciones = variants.length ? Object.keys(variants[0].options) : [];

      var moneyFormat = form.getAttribute('data-mt-money-format') || '{{amount}} €';
      var idInput = form.querySelector('input[name="id"]');
      // El precio vive fuera del <form> en el markup, así que se busca en todo el documento.
      var precioActual = document.querySelector('[data-mt-precio-actual]');
      var precioAnterior = document.querySelector('[data-mt-precio-anterior]');
      var subeProntoWrap = document.querySelector('[data-mt-sube-pronto]');
      var etiquetaOferta = document.querySelector('[data-mt-etiqueta-oferta]');
      var botonComprar = form.querySelector('[data-mt-boton-comprar]');
      var disponibilidad = form.querySelector('[data-mt-disponibilidad]');
      var pills = form.querySelectorAll('[data-mt-pill]');
      var galeriaPrincipal = document.querySelector('[data-mt-imagen-principal]');
      // Igual que en initProductoGaleria: el nombre de la opción "de
      // color" lo decide Liquid y puede no ser literalmente "Color"
      // (p. ej. "Diseño") — se lee del mismo atributo, para saber qué
      // grupo de pills debe avisar a la galería cuando cambia.
      var galeriaWrap = document.querySelector('[data-mt-galeria-producto]');
      var nombreOpcionColorForm = (galeriaWrap && galeriaWrap.getAttribute('data-mt-nombre-opcion-color')) || 'Color';

      function seleccionActual() {
        var seleccion = {};
        form.querySelectorAll('[data-mt-opcion]').forEach(function (grupo) {
          var activo = grupo.querySelector('.is-active');
          if (activo) seleccion[grupo.getAttribute('data-mt-opcion')] = activo.getAttribute('data-mt-pill');
        });
        return seleccion;
      }

      function encontrarVariante() {
        var seleccion = seleccionActual();
        return variants.find(function (v) {
          return Object.keys(seleccion).every(function (k) { return v.options[k] === seleccion[k]; });
        });
      }

      function actualizar() {
        var variante = encontrarVariante();
        if (!variante) return;
        if (idInput) idInput.value = variante.id;
        if (precioActual) precioActual.textContent = formatMoney(variante.price, moneyFormat);
        var hayOferta = variante.compare_at_price && variante.compare_at_price > variante.price;
        if (precioAnterior) precioAnterior.textContent = formatMoney(variante.compare_at_price, moneyFormat);
        if (subeProntoWrap) subeProntoWrap.style.display = hayOferta ? '' : 'none';
        if (etiquetaOferta) etiquetaOferta.style.display = hayOferta ? '' : 'none';
        if (botonComprar) botonComprar.disabled = !variante.available;
        if (disponibilidad) {
          if (variante.available) {
            disponibilidad.textContent = disponibilidad.getAttribute('data-mt-texto-disponible') || 'En stock';
            disponibilidad.classList.remove('is-agotado');
          } else {
            disponibilidad.textContent = disponibilidad.getAttribute('data-mt-texto-agotado') || 'Agotado';
            disponibilidad.classList.add('is-agotado');
          }
        }
        if (variante.featured_image && galeriaPrincipal) {
          galeriaPrincipal.src = variante.featured_image;
        }
        // Talla única: la guía de tallas no aplica, se oculta.
        var guiaTallas = document.querySelector('.mt-producto__tallas');
        if (guiaTallas) {
          var esTallaUnica = Object.keys(variante.options).some(function (k) { return variante.options[k] === 'Única'; });
          guiaTallas.hidden = esTallaUnica;
        }
      }

      // Algunos productos tienen combinaciones que no existen de verdad
      // (p. ej. el Collar Estampado Floral: el color "Black" solo viene en
      // "Talla única", y el color "Red A" solo en S/M/L/XL — no hay
      // variante "Black / S" ni "Red A / Única"). Sin esto, se podían
      // dejar activos a la vez un color y una talla que juntos no
      // correspondían a ninguna variante real: el formulario se quedaba
      // con el id de la última variante válida (sin avisar de nada), así
      // que se podía acabar comprando algo distinto a lo que parecía
      // elegido en pantalla. Se marcan como no disponibles (mismo estilo
      // ya preparado en el CSS, .mt-producto__pill:disabled) las opciones
      // que no forman variante real con lo demás ya elegido.
      function pillDisponible(nombreGrupo, valorPill, seleccion) {
        var anteriores = nombresOpciones.slice(0, nombresOpciones.indexOf(nombreGrupo));
        return variants.some(function (v) {
          if (v.options[nombreGrupo] !== valorPill) return false;
          return anteriores.every(function (k) { return v.options[k] === seleccion[k]; });
        });
      }

      function marcarActiva(pill) {
        var grupo = pill.closest('[data-mt-opcion]');
        grupo.querySelectorAll('[data-mt-pill]').forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        var labelActivo = grupo.querySelector('[data-mt-valor-activo]');
        if (labelActivo) labelActivo.textContent = mtTraducir(pill.getAttribute('data-mt-pill'));
      }

      function actualizarDisponibilidadPills() {
        var seleccion = seleccionActual();
        // Primera pasada: activar/desactivar cada pill según si forma
        // variante real junto con lo elegido en los DEMÁS grupos.
        pills.forEach(function (pill) {
          var nombreGrupo = pill.closest('[data-mt-opcion]').getAttribute('data-mt-opcion');
          pill.disabled = !pillDisponible(nombreGrupo, pill.getAttribute('data-mt-pill'), seleccion);
        });
        // Segunda pasada: si la opción activa de algún grupo se ha
        // quedado sin disponibilidad por el cambio en otro grupo (p. ej.
        // se tenía "S" activa y se acaba de elegir "Black"), se salta
        // sola a la primera opción de ese grupo que sí sea válida — así
        // nunca queda una combinación imposible seleccionada en pantalla.
        form.querySelectorAll('[data-mt-opcion]').forEach(function (grupo) {
          var activa = grupo.querySelector('[data-mt-pill].is-active');
          if (activa && !activa.disabled) return;
          var primeraValida = grupo.querySelector('[data-mt-pill]:not(:disabled)');
          if (primeraValida) marcarActiva(primeraValida);
        });
      }

      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          var grupo = pill.closest('[data-mt-opcion]');
          marcarActiva(pill);
          actualizarDisponibilidadPills();
          actualizar();
          if (grupo.getAttribute('data-mt-opcion') === nombreOpcionColorForm) {
            document.dispatchEvent(new CustomEvent('mt:color-changed', { detail: { color: pill.getAttribute('data-mt-pill') } }));
          }
        });
      });

      actualizarDisponibilidadPills();
      actualizar();
    });
  }

  // Ronda 138: el formulario de la ficha de producto (el `{% form
  // 'product', product %}` de más arriba) nunca llevaba JavaScript
  // propio que interceptara su envío — no se notaba mientras el
  // carrito era de tipo "Notificación" (siempre acababa en /cart de
  // todos modos), pero al pasar a barra lateral (Ronda 136) se vio
  // el problema: al pulsar "Añadir al carrito" desde dentro de una
  // ficha de producto, el formulario se enviaba de la forma normal
  // del navegador (recarga completa a /cart/add), así que la barra
  // lateral nunca llegaba a abrirse — en vez de eso, Shopify
  // redirigía directamente a la página del carrito.
  //
  // Aquí se intercepta ese envío para hacerlo por AJAX (como el
  // resto del carrito en esta tienda) y, si hay una barra lateral en
  // la página, se refresca con el producto recién añadido y se abre
  // — sin recargar nada. Si por lo que sea no hubiera barra lateral
  // (p. ej. si algún día se cambia el ajuste "Tipo de carrito"), cae
  // de vuelta al comportamiento de siempre: ir a la página del
  // carrito.
  function initEnvioFormularioProducto() {
    document.querySelectorAll('[data-mt-producto-form]').forEach(function (form) {
      form.addEventListener('submit', function (evt) {
        evt.preventDefault();
        var boton = form.querySelector('[data-mt-boton-comprar]') || form.querySelector('[type="submit"]');
        if (boton && boton.disabled) return;
        var textoOriginal = boton ? boton.textContent : null;
        if (boton) boton.disabled = true;

        // Igual que hace Dawn de fábrica en su propio product-form.js:
        // se piden ya de paso las secciones que necesita la barra
        // lateral (si la hay), para poder rellenarla con
        // drawer.renderContents(...) sin tener que hacer una segunda
        // vuelta a por el carrito.
        var drawer = document.querySelector('cart-drawer');
        var formData = new FormData(form);
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          formData.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
          formData.append('sections_url', window.location.pathname);
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        })
          .then(function (r) { return r.json(); })
          .then(function (respuesta) {
            if (respuesta.status) {
              // Fallo real (p. ej. se quedó sin stock justo ahora) — se
              // deja que el visitante lo intente desde la ficha, que ya
              // marca la disponibilidad; no hay más que reactivar el
              // botón.
              console.error('[mt] no se pudo añadir al carrito', respuesta);
              return;
            }

            // Ronda 146: igual que hace Dawn de fábrica en su propio
            // product-form.js (que este formulario no usa — Ronda 138).
            // Sin este aviso, el regalo automático (initRegaloAutomatico,
            // que solo se activa al recibir este mismo aviso) nunca se
            // enteraba de que se había añadido el Arnés por este camino —
            // el regalo tardaba en aparecer en la barra lateral hasta que
            // el cliente iba a /cart y esa página SÍ disparaba el aviso
            // (a través del propio Dawn). Con esto, se entera igual desde
            // aquí, y la barra lateral se actualiza sola en cuanto el
            // regalo se añade (misma vía que ya usa Dawn para refrescar
            // el cajón — CartItems#onCartUpdate, assets/cart.js).
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mt-producto-form', cartData: respuesta });
            }

            if (drawer && typeof drawer.renderContents === 'function' && respuesta.sections) {
              drawer.renderContents(respuesta);
              // El propio renderContents() de Dawn (assets/cart-drawer.js)
              // quita la clase "is-empty" de `.drawer__inner`, pero el
              // CSS que de verdad la usa para decidir qué se ve
              // (assets/component-cart-drawer.css) la mira en el propio
              // <cart-drawer> — un desajuste de fábrica que no se nota
              // casi nunca (normalmente ya hay algo en el carrito), pero
              // que aquí, al añadir el primer producto de un carrito
              // vacío, dejaba la cabecera y el resto oculto. Se quita
              // también del sitio correcto, a mano.
              drawer.classList.remove('is-empty');
              drawer.open();
            } else if (drawer && typeof drawer.open === 'function') {
              // No se pudieron pedir las secciones (drawer sin
              // getSectionsToRender, por lo que sea) — se abre igual,
              // aunque tarde un momento en verse el producto nuevo
              // hasta el siguiente refresco.
              drawer.open();
            } else {
              window.location.href = '/cart';
            }
          })
          .catch(function (err) {
            console.error('[mt] error de red al añadir al carrito', err);
          })
          .finally(function () {
            if (boton) {
              boton.disabled = false;
              if (textoOriginal !== null) boton.textContent = textoOriginal;
            }
          });
      });
    });
  }

  // Botón "Volver": si el visitante llegó navegando dentro de la tienda,
  // vuelve a la página anterior de verdad (historial real). Si no hay
  // historial (p. ej. llegó desde un anuncio o enlace externo), deja que
  // el enlace normal lleve a la URL de repuesto configurada en la sección.
  function initVolver() {
    document.querySelectorAll('[data-mt-volver]').forEach(function (link) {
      link.addEventListener('click', function (evt) {
        if (window.history.length > 1 && document.referrer && document.referrer.indexOf(window.location.origin) === 0) {
          evt.preventDefault();
          window.history.back();
        }
      });
    });
  }

  // Cuadro de código de descuento en la página del carrito (Dawn no trae
  // uno de serie, solo se podía escribir en el pago). Usa el mismo
  // mecanismo nativo /discount/<codigo> que ya usa "Arma tu pack".
  //
  // Ronda 149: ese endpoint nativo de Shopify no avisa de ningún modo
  // si el código no existe o no es válido — simplemente no lo aplica,
  // en silencio, y el cliente no se entera de si se equivocó al
  // escribirlo o si de verdad no existe ese código. Se guarda el
  // código que se acaba de intentar (en sessionStorage, porque
  // /discount/<codigo> navega de verdad a otra carga de página) y, ya
  // en /cart, se comprueba contra el carrito real si quedó aplicado o
  // no — si no, se avisa con un mensaje.
  var MT_CLAVE_CODIGO_INTENTADO = 'mt_codigo_descuento_intentado';

  function mtComprobarCodigoTrasRecarga(wrap) {
    var codigo;
    try { codigo = sessionStorage.getItem(MT_CLAVE_CODIGO_INTENTADO); } catch (e) { codigo = null; }
    if (!codigo) return;

    // El mensaje vive JUSTO DESPUÉS de este envoltorio en el HTML, no
    // dentro (a propósito — así el margen negativo que lo pega a la
    // fila de arriba, en assets/mt-styles.css, funciona bien), así que
    // se busca en toda la página, no con wrap.querySelector().
    var mensajeEl = document.querySelector('[data-mt-codigo-mensaje]');
    if (!mensajeEl) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var aplicado = (cart.discount_codes || []).some(function (dc) {
          return dc.applicable && dc.code.toLowerCase() === codigo.toLowerCase();
        });
        if (aplicado) {
          // Ya se ha visto que el código quedó bien aplicado — no hace
          // falta comprobar más veces si la página se recarga por
          // otro motivo aparte (ver más abajo por qué NO se borra
          // esto justo al leerlo).
          try { sessionStorage.removeItem(MT_CLAVE_CODIGO_INTENTADO); } catch (e) {}
          mensajeEl.hidden = true;
          mensajeEl.classList.remove('is-error');
          return;
        }
        // OJO — a propósito, NO se borra la marca de sessionStorage
        // aquí: la página del carrito puede recargarse sola por otro
        // motivo justo después de aplicar un código (por ejemplo, el
        // freno de mtReconciliarOrdenPack más arriba) — si se hubiera
        // borrado ya, ese aviso desaparecería sin que el cliente
        // llegara a verlo. Al dejarla puesta, si eso pasa, esta misma
        // comprobación se repite en la carga siguiente y el aviso
        // sigue ahí (inofensivo repetir la misma comprobación dos
        // veces). Solo se borra cuando el cliente escribe algo nuevo
        // (ver initCodigoCarrito) o cuando el código SÍ queda bien
        // aplicado (arriba).
        var plantilla = wrap.getAttribute('data-mt-mensaje-invalido') || '';
        mensajeEl.textContent = plantilla.replace('MT_CODIGO', codigo);
        mensajeEl.classList.add('is-error');
        mensajeEl.hidden = false;
      })
      .catch(function () {});
  }

  function initCodigoCarrito() {
    var wrap = document.querySelector('[data-mt-cart-descuento]');
    if (wrap) {
      var input = wrap.querySelector('[data-mt-codigo-input]');
      var boton = wrap.querySelector('[data-mt-codigo-aplicar]');
      if (input && boton) {
        var aplicar = function () {
          var codigo = input.value.trim();
          if (!codigo) return;
          boton.disabled = true;
          try { sessionStorage.setItem(MT_CLAVE_CODIGO_INTENTADO, codigo); } catch (e) {}
          window.location.href = '/discount/' + encodeURIComponent(codigo) + '?redirect=/cart';
        };
        boton.addEventListener('click', aplicar);
        input.addEventListener('keydown', function (evt) {
          if (evt.key === 'Enter') { evt.preventDefault(); aplicar(); }
        });
        // Si el cliente se pone a corregir lo que escribió, se quita
        // el aviso de "no válido" del intento anterior — ya no pinta
        // nada mientras decide qué escribir de nuevo.
        input.addEventListener('input', function () {
          try { sessionStorage.removeItem(MT_CLAVE_CODIGO_INTENTADO); } catch (e) {}
          var mensajeEl = document.querySelector('[data-mt-codigo-mensaje]');
          if (mensajeEl) mensajeEl.hidden = true;
        });
      }
      mtComprobarCodigoTrasRecarga(wrap);
    }

    // Ronda 142: por delegación en document, no un listener por cada
    // botón "x" (puede haber varias, una por cada código listado —
    // como Shopify solo permite un código activo a la vez, cualquiera
    // de ellas lo quita igual). Antes, poner el listener directamente
    // en cada botón dejaba de funcionar en cuanto la barra lateral se
    // volvía a pintar entera (drawer.renderContents(), Ronda 138 en
    // adelante) — el botón nuevo no tenía el listener puesto, así que
    // parecía "no hacer nada". Con delegación da igual cuántas veces
    // se repinte: sigue funcionando siempre.
    document.addEventListener('click', function (evt) {
      var quitarBoton = evt.target.closest('[data-mt-quitar-descuento]');
      if (!quitarBoton || quitarBoton.disabled) return;
      quitarBoton.disabled = true;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: '' }),
      })
        .then(function () { window.location.reload(); })
        .catch(function () { quitarBoton.disabled = false; });
    });
  }

  // Modal de confirmación propio (snippets/mt-modal-confirmar.liquid),
  // sustituye a window.confirm() — que es el aviso genérico y feo del
  // navegador, sin el estilo de la web. Devuelve una promesa que resuelve
  // a true/false según el botón que pulse el cliente (o Escape/fondo =
  // false). Si la página no tiene el snippet renderizado (id no
  // encontrado), cae de vuelta a window.confirm() para no dejar el botón
  // sin funcionar.
  function mtConfirmar(id, texto) {
    return new Promise(function (resolve) {
      var modal = document.querySelector('[data-mt-modal="' + id + '"]');
      if (!modal) { resolve(window.confirm(texto)); return; }

      var textoEl = modal.querySelector('[data-mt-modal-texto]');
      var btnAceptar = modal.querySelector('[data-mt-modal-aceptar]');
      var btnCancelar = modal.querySelector('[data-mt-modal-cancelar]');
      var fondo = modal.querySelector('[data-mt-modal-fondo]');
      if (textoEl) textoEl.textContent = texto;

      modal.hidden = false;
      document.body.classList.add('mt-modal-abierto');

      function cerrar(resultado) {
        modal.hidden = true;
        document.body.classList.remove('mt-modal-abierto');
        btnAceptar.removeEventListener('click', onAceptar);
        btnCancelar.removeEventListener('click', onCancelar);
        fondo.removeEventListener('click', onCancelar);
        document.removeEventListener('keydown', onTecla);
        resolve(resultado);
      }
      function onAceptar() { cerrar(true); }
      function onCancelar() { cerrar(false); }
      function onTecla(evt) { if (evt.key === 'Escape') cerrar(false); }

      btnAceptar.addEventListener('click', onAceptar);
      btnCancelar.addEventListener('click', onCancelar);
      fondo.addEventListener('click', onCancelar);
      document.addEventListener('keydown', onTecla);
      btnCancelar.focus();
    });
  }

  // Ronda 143: /cart/clear.js solo vacía las líneas — el código de
  // descuento aplicado (BRUMA) NO se quita solo, se queda pegado a la
  // sesión del carrito. El usuario pidió justo lo contrario: si el
  // carrito se vacía, el código también debe quitarse, para que haga
  // falta volver a escribirlo la próxima vez (si no, el descuento
  // "reaparecía" solo en el carrito siguiente, sin que el cliente
  // hubiera vuelto a introducir nada). Mismo mecanismo que ya usaba el
  // botón "x" de quitar código (initCodigoCarrito), aquí reutilizado.
  function mtQuitarCodigoDescuento() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: '' }),
    });
  }

  // Botón "Vaciar carrito" — puede haber más de uno en la misma página
  // (el de la página completa del carrito y el de la barra lateral,
  // que está en todas las páginas; Ronda 140). Cada botón usa su
  // propio modal de confirmación (data-mt-modal-id), para no compartir
  // el mismo id de HTML entre los dos.
  //
  // Ronda 142: puesto por delegación en document, no con un
  // "addEventListener" directo en cada botón — igual que se explica en
  // initCodigoCarrito(), el botón de la barra lateral se pierde y se
  // vuelve a crear cada vez que se repinta el cajón entero
  // (drawer.renderContents(), Ronda 138 en adelante: pasa nada más
  // añadir algo desde una ficha de producto o desde "Arma tu pack"), y
  // el botón NUEVO no llevaba puesto el listener de antes — por eso
  // dejaba de "hacer algo" después de esas acciones. Con delegación no
  // importa cuántas veces se repinte: el botón que haya en cada
  // momento sigue funcionando.
  //
  // Al vaciar desde la barra lateral no tiene sentido recargar la
  // página entera (rompería justo lo que se acaba de arreglar en la
  // Ronda 136/138: que el carrito se pueda ver y tocar sin salir de
  // donde esté el cliente) — ahí se refresca solo el propio cajón, con
  // el mismo mecanismo que ya usa "Añadir al carrito" (Ronda 138).
  function initVaciarCarrito() {
    document.addEventListener('click', function (evt) {
      var boton = evt.target.closest('[data-mt-cart-vaciar]');
      if (!boton || boton.disabled) return;

      var enBarraLateral = !!boton.closest('cart-drawer');
      var modalId = boton.getAttribute('data-mt-modal-id') || 'vaciar-carrito';

      mtConfirmar(modalId, '¿Seguro que quieres vaciar el carrito?').then(function (siConfirma) {
        if (!siConfirma) return;
        boton.disabled = true;

        if (enBarraLateral) {
          var drawer = document.querySelector('cart-drawer');
          var url = '/cart/clear.js';
          if (drawer && typeof drawer.getSectionsToRender === 'function') {
            url += '?sections=' + encodeURIComponent(
              drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',')
            );
          }
          fetch(url, { method: 'POST', headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (respuesta) {
              return mtQuitarCodigoDescuento().catch(function () {}).then(function () { return respuesta; });
            })
            .then(function (respuesta) {
              if (drawer && typeof drawer.renderContents === 'function' && respuesta.sections) {
                drawer.renderContents(respuesta);
                // Al revés que al añadir (Ronda 138, que la quita):
                // ahora el carrito SÍ está vacío de verdad, así que
                // hay que ponerla — mismo desajuste de fábrica de
                // Dawn explicado allí (renderContents() la toca en
                // .drawer__inner, pero el CSS la mira en el propio
                // <cart-drawer>).
                drawer.classList.add('is-empty');
              } else {
                window.location.reload();
              }
            })
            .catch(function () { window.location.reload(); })
            .finally(function () { boton.disabled = false; });
          return;
        }

        fetch('/cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: '{}',
        })
          .then(function () { return mtQuitarCodigoDescuento().catch(function () {}); })
          .then(function () { window.location.reload(); })
          .catch(function () { boton.disabled = false; });
      });
    });
  }

  // Regalo automático: mientras el Arnés Vaquero Tipo Chaleco (id
  // 16089851429244, producto disparador — antes era la Camisa a Cuadros
  // Vichy, movido en la Ronda 115) esté en el carrito, se añade sola una
  // unidad del regalo real — el 100% de descuento en esa unidad lo aplica
  // un descuento automático ya configurado en Shopify (Admin →
  // Descuentos), no este script; aquí solo se encarga de que la línea del
  // regalo entre y salga del carrito sola, sin que el cliente tenga que
  // añadirlo/quitarlo a mano. Pareja fija para este caso concreto (no es
  // un mecanismo genérico reutilizable con otros productos, aunque tanto
  // el disparador como el propio regalo ya se han cambiado alguna vez).
  //
  // IMPORTANTE — fallo real corregido el 27 de septiembre: el 4 de
  // septiembre se cambió el regalo de "Mordedor Dental" a "Collar
  // Estampado Floral" (id 16087322296700) en la ficha del producto
  // (mt-producto.liquid: foto, nombre y botones de color ya apuntaban al
  // collar) y en el descuento automático de Shopify (que ya daba el 100%
  // sobre el collar) — pero aquí, en el script que de verdad decide qué se
  // añade al carrito, se quedaron sin actualizar el ID de producto y la
  // lista de variantes válidas, que seguían siendo las del Mordedor. Efecto
  // real: el cliente elegía un color de collar en la ficha, pero lo que se
  // añadía al carrito era siempre el Mordedor Dental (rosa) — y como el
  // descuento automático apunta al collar, no al Mordedor, ese Mordedor se
  // cobraba a precio completo en vez de salir gratis. Si se vuelve a
  // cambiar el producto del regalo en el futuro, HAY QUE actualizar los
  // tres a la vez: el producto/variantes aquí abajo, la ficha en
  // mt-producto.liquid, y el descuento automático "Regalo" en Shopify.
  //
  // (Hubo una ronda intermedia, revertida, en la que este regalo usaba un
  // producto "espejo" invisible en vez del real, para que no se colara un
  // 5% extra de "Arma tu pack" al comprar solo el disparador. Se deshizo
  // porque ocultar un producto de todos los listados del catálogo deja
  // huecos en la rejilla de "Todos los productos" sin arreglo fiable solo
  // con Liquid — se prefirió usar el producto real y aceptar ese 5%
  // ocasional, con la idea de revisarlo más adelante de otra forma.)
  //
  // Color del regalo: el cliente lo elige en la ficha del producto
  // disparador (bloque `[data-mt-regalo-color-picker]`, ver initSelectorColorRegalo más
  // abajo). La elección se guarda en localStorage (clave
  // MT_REGALO_COLOR_STORAGE_KEY) como el ID DE VARIANTE elegido, no su
  // nombre — el nombre de color que da Liquid (`variant.option1`) viene ya
  // traducido según el idioma del visitante, así que compararlo como texto
  // se rompía en español; el ID de variante es el mismo pase lo que pase
  // con el idioma. No se guarda como propiedad del pedido: el color elegido
  // ya queda registrado solo con la VARIANTE del propio regalo que se
  // añade (el pedido final ya lo enseña sin necesitar nada más). Si el
  // cliente cambia de color después de que el regalo ya esté en el
  // carrito, `comprobarYAjustar` lo detecta (compara la variante actual del
  // regalo con la preferida) y cambia la línea sola, sin recargar nada.
  //
  // El nombre de la clave de localStorage y el valor de la propiedad del
  // pedido (más abajo, VALOR_PROPIEDAD_REGALO) mencionan "mordedor" por
  // motivos históricos — no se renombran para no invalidar carritos ya
  // guardados en el navegador de clientes actuales ni líneas de pedidos
  // antiguos, aunque el regalo real ya no sea el Mordedor.
  var MT_REGALO_COLOR_STORAGE_KEY = 'mt_color_regalo_mordedor';
  // Esta lista es solo la RED DE SEGURIDAD para páginas donde no está el
  // selector completo (todas menos la ficha del Arnés) — en la ficha del
  // disparador, initSelectorColorRegalo lee las variantes REALES en vivo
  // (data-mt-regalo-variantes-json) y no depende de esta lista para
  // funcionar bien. Aun así, si el regalo cambia de variantes otra vez,
  // hay que actualizarla también — el mecanismo en sí evita que un olvido
  // aquí cobre de más al cliente (como pasó el 27 de septiembre), pero sí
  // puede hacer que el regalo por defecto no sea el más reciente si el
  // cliente nunca pasa por la ficha del Arnés antes de comprarlo.
  var MT_REGALO_VARIANTES_VALIDAS = [
    57328544743804, // Black / Única
    57508717822332, // Red / S
    57508717855100, // Red / M
    57508717887868, // Red / L
    57508717920636, // Red / XL
  ];
  var MT_REGALO_VARIANTE_DEFECTO = 57328544743804; // Black / Única

  function mtVarianteRegaloPreferida() {
    try {
      var guardado = parseInt(localStorage.getItem(MT_REGALO_COLOR_STORAGE_KEY), 10);
      if (MT_REGALO_VARIANTES_VALIDAS.indexOf(guardado) !== -1) return guardado;
    } catch (e) {}
    return MT_REGALO_VARIANTE_DEFECTO;
  }

  // Expuesta para que initSelectorColorRegalo pueda pedir una re-comprobación
  // en cuanto el cliente cambia el color preferido, sin esperar a que el
  // carrito cambie por otro motivo.
  var mtRegaloComprobarYAjustar = null;

  function initRegaloAutomatico() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    var ID_PRODUCTO_DISPARADOR = 16089851429244; // Arnés Vaquero Tipo Chaleco
    var ID_PRODUCTO_REGALO = 16087322296700; // Collar Estampado Floral — corregido 27 sept, antes apuntaba por error al Mordedor Dental (16085373616508)
    var PROPIEDAD_REGALO = '_mt_regalo';
    var VALOR_PROPIEDAD_REGALO = 'mordedor_camisa_vichy'; // nombre histórico de la propiedad, no se cambia para no invalidar líneas ya creadas con carritos antiguos
    var FUENTE_EVENTO = 'mt-regalo-automatico';
    var ajustando = false; // evita que el propio cambio del regalo se relea a sí mismo en bucle
    // Aparte de "ajustando" (que cubre mientras el regalo se está
    // añadiendo/quitando de verdad): esta otra marca cubre el hueco de
    // ANTES de eso — mientras se está decidiendo qué hacer (la lectura
    // de /cart.js, que es async). Se comprobó que dos avisos de cambio
    // de carrito casi seguidos podían pasar los dos la comprobación de
    // "ajustando" (porque esa solo se pone a "true" DENTRO de
    // anadirRegalo/quitarRegalo, que es donde se llega ya DESPUÉS de la
    // decisión) y acabar los dos decidiendo lo mismo a la vez — por
    // ejemplo, añadir el regalo dos veces.
    var comprobando = false;

    function tieneDisparador(cart) {
      return cart.items.some(function (item) { return item.product_id === ID_PRODUCTO_DISPARADOR; });
    }
    function lineaRegalo(cart) {
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if (item.product_id === ID_PRODUCTO_REGALO && item.properties && item.properties[PROPIEDAD_REGALO] === VALOR_PROPIEDAD_REGALO) {
          // Por "key" (fijo), no por posición — mismo motivo que en
          // mtArreglarMarcaLinea(): la posición puede quedar
          // desactualizada si esto coincide con otra alta al carrito
          // casi a la vez.
          return { item: item, clave: item.key };
        }
      }
      return null;
    }
    function avisarCambioCarrito(cart) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: FUENTE_EVENTO, cartData: cart });
    }

    // La página del carrito tiene un resumen de descuentos agrupados (en
    // sections/main-cart-footer.liquid) que Dawn solo refresca por AJAX
    // cuando el cambio lo inicia la propia página del carrito — cuando lo
    // inicia este script (p. ej. el regalo entra/sale/cambia mientras el
    // cliente ya está viendo /cart), esa sección se queda con el aspecto de
    // antes hasta recargar a mano. En vez de perseguir ese comportamiento
    // de Dawn (comprobado que además la sección puede llegar vacía al
    // pedirla sola por AJAX en este entorno), la solución simple: si el
    // cambio de verdad ocurrió y el cliente está en /cart en ese momento,
    // se recarga la página sola.
    function estamosEnPaginaCarrito() {
      return /\/cart\/?$/.test(window.location.pathname);
    }

    function comprobarYAjustar() {
      if (ajustando || comprobando) return;
      comprobando = true;
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var conDisparador = tieneDisparador(cart);
          var regalo = lineaRegalo(cart);
          var varianteDeseada = mtVarianteRegaloPreferida();
          if (conDisparador && !regalo) {
            anadirRegalo(varianteDeseada, true);
          } else if (!conDisparador && regalo) {
            quitarRegalo(regalo.clave, null, true);
          } else if (conDisparador && regalo && regalo.item.variant_id !== varianteDeseada) {
            // El cliente cambió el color preferido con el regalo ya puesto:
            // se quita la línea del color viejo y se añade la del nuevo.
            // La recarga (si toca) se pide solo al final del todo, no tras
            // el paso intermedio de quitar.
            quitarRegalo(regalo.clave, function () { anadirRegalo(varianteDeseada, true); }, false);
          }
        })
        .catch(function () {})
        .finally(function () { comprobando = false; });
    }
    mtRegaloComprobarYAjustar = comprobarYAjustar;

    function anadirRegalo(varianteId, recargarSiEnCarrito) {
      ajustando = true;
      var propiedades = {};
      propiedades[PROPIEDAD_REGALO] = VALOR_PROPIEDAD_REGALO;
      var huboExito = false;
      // Encolada junto con las escrituras de mtReconciliarOrdenPack: así
      // esta alta nunca coincide en el aire con una de esas — ver
      // mtEncolarMutacionCarrito() más arriba del todo del archivo.
      mtEncolarMutacionCarrito(function () {
        // Antes de añadir de verdad, se relee el carrito UNA VEZ MÁS,
        // ya dentro de la cola — se comprobó un caso real en el que la
        // decisión de "falta el regalo" se tomaba con una lectura que
        // se quedó desactualizada (por ejemplo, justo tras recargar la
        // página mientras la alta anterior del regalo todavía no había
        // terminado de verdad), y acababa poniendo un SEGUNDO regalo,
        // cobrado a precio completo. Con esta relectura de última hora,
        // si para cuando de verdad le toca el turno en la cola el
        // regalo YA está puesto, no se añade nada más.
        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cartActual) {
            if (lineaRegalo(cartActual)) { huboExito = false; return null; }
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: varianteId, quantity: 1, properties: propiedades }] }),
            })
              .then(function () { return fetch('/cart.js'); })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                huboExito = true;
                avisarCambioCarrito(cart);
              });
          })
          .catch(function () {});
      })
        .finally(function () {
          ajustando = false;
          // Recarga solo si de verdad se consiguió añadir — si algo falló
          // (p. ej. sin stock de ese color), recargar solo repetiría el
          // mismo fallo sin fin.
          if (huboExito && recargarSiEnCarrito && estamosEnPaginaCarrito()) window.location.reload();
        });
    }

    function quitarRegalo(clave, alTerminar, recargarSiEnCarrito) {
      ajustando = true;
      var huboExito = false;
      mtEncolarMutacionCarrito(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: clave, quantity: 0 }),
        })
          .then(function () { return fetch('/cart.js'); })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            huboExito = true;
            avisarCambioCarrito(cart);
          })
          .catch(function () {});
      })
        .finally(function () {
          ajustando = false;
          if (typeof alTerminar === 'function') {
            alTerminar();
          } else if (huboExito && recargarSiEnCarrito && estamosEnPaginaCarrito()) {
            window.location.reload();
          }
        });
    }

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event.source === FUENTE_EVENTO) return;
      comprobarYAjustar();
    });

    // Comprobación inicial al cargar cualquier página — por ejemplo, si el
    // carrito ya traía el disparador sin el regalo (o al revés) de antes de
    // esta función, o tras recargar la página del carrito sin pasar por
    // ningún evento de carrito.
    comprobarYAjustar();
  }

  // Selector "Elige el color (y talla) de tu regalo" de la ficha del
  // producto disparador (Arnés Vaquero Tipo Chaleco desde la Ronda 115)
  // (bloque `[data-mt-regalo-color-picker]` en sections/mt-producto.liquid,
  // solo se pinta en esa ficha). Guarda la preferencia (la variante EXACTA:
  // color + talla) en localStorage y, si el regalo ya está puesto en el
  // carrito con otra variante, pide una re-comprobación inmediata para que
  // cambie sin recargar la página.
  //
  // Un botón por COLOR (no uno por variante): un color con varias tallas
  // (p. ej. "Red", con S/M/L/XL) solo aparece UNA vez en la fila de
  // colores — al elegirlo aparece debajo una segunda fila con sus tallas
  // reales. Un color de talla única (p. ej. "Black") no muestra ninguna
  // fila de tallas, no hay nada que elegir ahí. Las variantes reales se
  // leen del JSON que pinta Liquid (data-mt-regalo-variantes-json) en vez
  // de tener una lista escrita a fuego — ver el aviso junto a
  // MT_REGALO_VARIANTES_VALIDAS más arriba sobre por qué.
  function initSelectorColorRegalo() {
    var contenedor = document.querySelector('[data-mt-regalo-color-picker]');
    if (!contenedor) return;

    var datosEl = contenedor.querySelector('[data-mt-regalo-variantes-json]');
    var variantes;
    try { variantes = JSON.parse(datosEl.textContent); } catch (e) { return; }
    if (!variantes || !variantes.length) return;

    var botonesColor = contenedor.querySelectorAll('[data-mt-regalo-color]');
    var filaTallas = contenedor.querySelector('[data-mt-regalo-tallas]');
    var etiquetaActiva = contenedor.querySelector('[data-mt-regalo-color-activo]');
    var fotoGrande = contenedor.querySelector('[data-mt-regalo-foto]');

    function variantesDelColor(color) {
      return variantes.filter(function (v) { return v.color === color; });
    }

    var varianteGuardadaId = mtVarianteRegaloPreferida();
    var varianteGuardada = variantes.filter(function (v) { return v.id === varianteGuardadaId; })[0] || variantes[0];
    var colorActivo = varianteGuardada.color;
    var tallaActiva = varianteGuardada.talla;

    function guardarYAvisar(variante) {
      try { localStorage.setItem(MT_REGALO_COLOR_STORAGE_KEY, String(variante.id)); } catch (e) {}
      if (typeof mtRegaloComprobarYAjustar === 'function') mtRegaloComprobarYAjustar();
    }

    function actualizarVista() {
      var lista = variantesDelColor(colorActivo);
      if (!lista.length) return;
      // Si la talla activa no pertenece ya a este color (p. ej. se
      // acaba de cambiar de "Red / M" a "Black"), se coge la primera
      // talla real de este color en su lugar.
      if (!lista.some(function (v) { return v.talla === tallaActiva; })) {
        tallaActiva = lista[0].talla;
      }
      var variante = lista.filter(function (v) { return v.talla === tallaActiva; })[0] || lista[0];

      botonesColor.forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-mt-regalo-color') === colorActivo);
      });

      filaTallas.innerHTML = '';
      if (lista.length > 1) {
        lista.forEach(function (v) {
          var pill = document.createElement('button');
          pill.type = 'button';
          pill.className = 'mt-producto__pill' + (v.talla === tallaActiva ? ' is-active' : '');
          pill.textContent = v.talla;
          pill.addEventListener('click', function () {
            tallaActiva = v.talla;
            actualizarVista();
            guardarYAvisar(v);
          });
          filaTallas.appendChild(pill);
        });
        filaTallas.hidden = false;
      } else {
        filaTallas.hidden = true;
      }

      var etiquetaColor = mtTraducir(colorActivo);
      var etiquetaCompleta = lista.length > 1 ? (etiquetaColor + ' / ' + variante.talla) : etiquetaColor;
      if (etiquetaActiva) etiquetaActiva.textContent = etiquetaCompleta;
      if (fotoGrande && variante.foto) {
        fotoGrande.src = variante.foto;
        fotoGrande.alt = etiquetaCompleta;
      }
      return variante;
    }

    botonesColor.forEach(function (boton) {
      boton.addEventListener('click', function () {
        colorActivo = boton.getAttribute('data-mt-regalo-color');
        var variante = actualizarVista();
        guardarYAvisar(variante);
      });
    });

    actualizarVista();
  }

  // Buscador en vivo de la rejilla de productos (/collections/*): filtra las
  // tarjetas por nombre a medida que se escribe, sin distinguir mayúsculas
  // ni tildes, y encontrando la palabra en cualquier parte del título.
  function normalizarTexto(s) {
    return (s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .trim();
  }

  function initBuscarProductos() {
    var wrap = document.querySelector('[data-mt-buscar-productos]');
    if (!wrap) return;
    var input = wrap.querySelector('[data-mt-buscar-input]');
    var vacioEl = wrap.querySelector('[data-mt-buscar-vacio]');
    var borrarBtn = wrap.querySelector('[data-mt-buscar-borrar]');
    var idRejilla = wrap.getAttribute('data-mt-buscar-objetivo') || 'product-grid';
    var rejillaInicial = document.getElementById(idRejilla);
    if (!input || !rejillaInicial) return;

    // ID de la sección (para pedirle a Shopify solo su HTML al traer
    // otras páginas — ver cargarExtras() — en vez de la página entera
    // con cabecera, pie, etc. tres veces más pesada y más lenta).
    var contenedorSeccionInicial = rejillaInicial.closest('[id^="shopify-section-"]');
    var idSeccion = contenedorSeccionInicial ? contenedorSeccionInicial.id.replace(/^shopify-section-/, '') : null;

    // El buscador tiene que encontrar productos de CUALQUIER página, no
    // solo de la que se tenga abierta (Shopify solo carga en el HTML los
    // productos de la página actual). Truco: en cuanto se escribe algo
    // por primera vez, se traen por detrás el resto de páginas de la
    // colección (peticiones normales, la misma URL con ?page=2, ?page=3…)
    // y se cuelan sus tarjetas al final de la rejilla, ocultas — así,
    // para cuando se filtra, ya están todas disponibles para comparar.
    // Mientras no se busque nada, esas tarjetas "de otra página" se
    // quedan siempre ocultas, para no romper la paginación normal.
    var extrasListas = false;
    var extrasEnCurso = null;
    var ignorarMutaciones = false;
    var nativasSinCascada = false;
    // Categoría elegida en sections/mt-categorias.liquid ('' = todas).
    // Vive aquí (no en su propia función) para compartir con el
    // buscador de texto el mismo "cargarExtras"/"filtrar"/observador de
    // Shopify — así los dos criterios (texto + categoría) se combinan
    // sin duplicar toda la lógica de traer otras páginas.
    var categoriaActiva = '';

    // Paginación de los resultados filtrados (texto y/o categoría). No es
    // la paginación nativa de Shopify (esa se basa en el total de TODA la
    // colección, sin saber nada del filtro) — es un paginador propio, con
    // el mismo tamaño de página que la rejilla normal
    // (`data-mt-por-pagina`, escrito por Liquid desde
    // `section.settings.products_per_page`), que reparte en páginas los
    // productos YA filtrados (todos fundidos en la rejilla por
    // cargarExtras()). "página 1" siempre al cambiar de filtro.
    var productosPorPagina = parseInt(rejillaInicial.getAttribute('data-mt-por-pagina'), 10) || 16;
    var paginaFiltroActiva = 1;

    // OJO: nunca guardar la rejilla en una variable fija — cuando se
    // cambia el "Ordenar por" o un filtro nativo de Shopify (Disponibilidad,
    // Precio...), Shopify vuelve a pintar toda la rejilla por su cuenta,
    // y el elemento de antes puede quedar reemplazado por uno nuevo. Hay
    // que volver a buscarla cada vez que se necesite.
    function rejillaActual() {
      return document.getElementById(idRejilla);
    }

    // La página en la que YA está el cliente (los productos de esa
    // página son los únicos que Shopify ha puesto de verdad en el HTML,
    // los demás hay que traerlos aparte).
    function paginaActual() {
      var n = parseInt(new URL(window.location.href).searchParams.get('page'), 10);
      return n && n > 0 ? n : 1;
    }

    function totalPaginas() {
      // OJO — otro fallo relacionado con el de más abajo: el paginador
      // de Shopify NO pone enlace a la página en la que ya se está (solo
      // enlaces a las demás), así que si se está en la página 2 de 2,
      // aquí solo aparece un enlace a la página 1 — sin contar la propia
      // página actual, parecería que solo hay 1 página en total. Por eso
      // el mínimo de partida es la página actual, no fijo en 1.
      var max = paginaActual();
      document.querySelectorAll('.pagination a[href*="page="]').forEach(function (a) {
        var m = a.href.match(/[?&]page=(\d+)/);
        if (m) max = Math.max(max, parseInt(m[1], 10));
      });
      return max;
    }

    function urlPagina(n) {
      var url = new URL(window.location.href);
      url.searchParams.set('page', n);
      // Con el ID de la sección, Shopify devuelve solo su HTML (unos
      // 3 veces menos pesado que la página entera con cabecera, pie,
      // etc.) — bastante más rápido, y lo que importa más cuando hay
      // que traer varias páginas a la vez.
      if (idSeccion) url.searchParams.set('section_id', idSeccion);
      return url.toString();
    }

    function cargarExtras() {
      if (extrasListas) return Promise.resolve();
      if (extrasEnCurso) return extrasEnCurso;
      var total = totalPaginas();
      if (total <= 1) { extrasListas = true; return Promise.resolve(); }
      // OJO — aquí estaba el fallo: se daba por hecho que el cliente
      // siempre empezaba en la página 1 (por eso se traían "las demás",
      // de la 2 en adelante). Si el cliente filtraba estando ya en la
      // página 2 (o cualquier otra), esa suposición era falsa: la
      // página 1 de verdad nunca se traía, así que los productos que
      // solo estaban ahí no aparecían nunca al filtrar por categoría o
      // buscar texto. Ahora se trae CUALQUIER página que no sea la
      // actual, sea cual sea esta.
      var actual = paginaActual();
      var paginas = [];
      for (var n = 1; n <= total; n++) {
        if (n !== actual) paginas.push(n);
      }
      var itemsPorPagina = {}; // n -> array de tarjetas ya importadas, todavía sin insertar en la rejilla
      extrasEnCurso = Promise.all(paginas.map(function (n) {
        return fetch(urlPagina(n))
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var otraRejilla = doc.getElementById(idRejilla);
            if (!otraRejilla) return;
            var copias = [];
            otraRejilla.querySelectorAll('.grid__item').forEach(function (item) {
              var copia = document.importNode(item, true);
              copia.setAttribute('data-mt-buscar-extra', 'true');
              // Quitar la animación de aparición "en cascada" de Dawn
              // (settings.animations_reveal_on_scroll): estas tarjetas
              // vienen de otra página, nunca han hecho esa animación de
              // entrada, así que si se dejan tal cual, en cuanto se
              // muestren (al filtrar) Dawn las anima UNA A UNA, con
              // retraso entre cada una — se ve como si fueran
              // apareciendo poco a poco, en vez de todas a la vez como
              // las nativas (que ya hicieron esa animación al cargar la
              // página y no la repiten al mostrarlas/ocultarlas).
              copia.classList.remove('scroll-trigger', 'animate--slide-in');
              copia.removeAttribute('data-cascade');
              copia.style.removeProperty('--animation-order');
              copia.style.display = 'none';
              copias.push(copia);
            });
            itemsPorPagina[n] = copias;
          })
          .catch(function () {
            // Si una página falla, se sigue con las demás — mejor
            // encontrar algunos productos de más que ninguno.
          });
      })).then(function () {
        var destino = rejillaActual();
        if (!destino) { extrasListas = true; extrasEnCurso = null; return; }
        // Se insertan las tarjetas de cada página en su sitio de
        // verdad (antes o después de las nativas, según el número de
        // página) — así el orden final es siempre el mismo, empiece el
        // cliente por la página que empiece, y sin tener que mover
        // NUNCA las tarjetas nativas de sitio (moverlas confundía al
        // vigilante de cambios de Shopify — MutationObserver más abajo
        // — que las interpretaba como un repintado de Shopify y volvía
        // a traer todo de nuevo sin parar, duplicando tarjetas). Las
        // páginas anteriores a la actual, en orden, antes de la
        // primera tarjeta nativa; las posteriores, en orden, al final.
        ignorarMutaciones = true;
        var primerNativo = destino.querySelector('.grid__item:not([data-mt-buscar-extra])');
        var paginasAntes = paginas.filter(function (n) { return n < actual; }).sort(function (a, b) { return a - b; });
        var paginasDespues = paginas.filter(function (n) { return n > actual; }).sort(function (a, b) { return a - b; });
        paginasAntes.forEach(function (n) {
          (itemsPorPagina[n] || []).forEach(function (copia) {
            if (primerNativo) destino.insertBefore(copia, primerNativo);
            else destino.appendChild(copia);
          });
        });
        paginasDespues.forEach(function (n) {
          (itemsPorPagina[n] || []).forEach(function (copia) {
            destino.appendChild(copia);
          });
        });
        ignorarMutaciones = false;
        extrasListas = true;
        extrasEnCurso = null;
      });
      return extrasEnCurso;
    }

    function hayFiltroActivo() {
      return input.value !== '' || categoriaActiva !== '';
    }

    // A petición del usuario: el aviso de "sin resultados" no debe
    // quedarse pegado al buscador de texto, sino aparecer justo debajo
    // del bloque de filtros nativos de Shopify ("Filtrar:" + chips +
    // "Eliminar todos") y encima de la rejilla. Como ese bloque
    // (#main-collection-filters) vive en una sección distinta y Shopify
    // lo vuelve a pintar entero cada vez que cambia un filtro o el
    // orden, hay que re-colocar el aviso cada vez que se filtra, no
    // solo la primera vez.
    function moverMensajeVacio() {
      if (!vacioEl) return;
      var aside = document.getElementById('main-collection-filters');
      if (!aside || aside.nextElementSibling === vacioEl) return;
      ignorarMutaciones = true;
      vacioEl.classList.add('mt-buscador__vacio--reubicado', 'mt-container');
      aside.insertAdjacentElement('afterend', vacioEl);
      ignorarMutaciones = false;
    }

    // Paginador PROPIO para cuando hay texto escrito o una categoría
    // elegida. cargarExtras() ya ha traído y fundido en la rejilla TODOS
    // los productos de TODAS las páginas reales de la colección, así que
    // lo filtrado nunca coincide con la paginación nativa de Shopify (esa
    // se calcula sobre el total de la colección ENTERA, sin saber nada
    // del filtro) — por eso el paginador nativo se oculta mientras haya
    // un filtro activo, y este otro (mismo tamaño de página,
    // `productosPorPagina`) reparte en páginas los resultados YA
    // filtrados, igual que se ve en "Todos" pero con la cuenta correcta:
    // si lo filtrado no llena ni la primera página, no aparece página 2.

    // Icono de flecha y textos accesibles reutilizados del paginador
    // nativo (siempre está en el DOM en este punto si la colección
    // completa tiene más de una página, aunque luego se oculte) para que
    // el paginador propio se vea y "suene" (lectores de pantalla)
    // exactamente igual que en "Todos" — textos ya en el idioma correcto
    // de la tienda (es/en), sin tenerlos que traducir aquí a mano.
    var iconoFlechaHtml = (function () {
      var svg = document.querySelector('.pagination .svg-wrapper');
      return svg ? svg.innerHTML : '';
    })();
    var etiquetaNavegacion = (function () {
      var nav = document.querySelector('.pagination');
      return (nav && nav.getAttribute('aria-label')) || 'Paginación';
    })();
    var etiquetaAnterior = (function () {
      var a = document.querySelector('.pagination__item--next');
      return (a && a.getAttribute('aria-label')) || 'Anterior';
    })();
    var etiquetaSiguiente = (function () {
      var a = document.querySelector('.pagination__item--prev');
      return (a && a.getAttribute('aria-label')) || 'Siguiente';
    })();
    // Plantilla para "Página N" (p. ej. de un enlace real a la página 2):
    // se reutiliza cambiando solo el número, así queda en el idioma real
    // de la tienda sin tener que traducirlo a mano aquí.
    var plantillaEtiquetaPagina = (function () {
      var a = document.querySelector('.pagination a[href*="page="]:not(.pagination__item-arrow)');
      return (a && a.getAttribute('aria-label')) || null;
    })();
    function etiquetaPagina(n) {
      return plantillaEtiquetaPagina ? plantillaEtiquetaPagina.replace(/\d+/, n) : 'Página ' + n;
    }

    var wrapperPaginacionFiltro = null;

    // Igual que rejillaActual(): nunca fiarse de la referencia guardada,
    // Shopify puede repintar (y por tanto destruir) todo el contenedor
    // cuando cambia el "Ordenar por" o un filtro nativo — hay que volver
    // a crearla si ya no está en la página.
    function paginacionFiltroWrapper() {
      if (wrapperPaginacionFiltro && document.body.contains(wrapperPaginacionFiltro)) {
        return wrapperPaginacionFiltro;
      }
      var rejilla = rejillaActual();
      if (!rejilla) return null;
      ignorarMutaciones = true;
      wrapperPaginacionFiltro = document.createElement('div');
      wrapperPaginacionFiltro.className = 'pagination-wrapper';
      wrapperPaginacionFiltro.setAttribute('data-mt-paginacion-filtro', '');
      wrapperPaginacionFiltro.hidden = true;
      rejilla.insertAdjacentElement('afterend', wrapperPaginacionFiltro);
      ignorarMutaciones = false;
      return wrapperPaginacionFiltro;
    }

    function irAPaginaFiltro(n) {
      if (n === paginaFiltroActiva) return;
      paginaFiltroActiva = n;
      filtrar();
    }

    // Dibuja el paginador propio para "totalCoincidencias" resultados
    // filtrados. Devuelve la página (ya ajustada si hacía falta) para que
    // filtrar() sepa qué tramo de resultados enseñar.
    function actualizarPaginacionFiltro(totalCoincidencias) {
      var wrapper = paginacionFiltroWrapper();
      if (!wrapper) return paginaFiltroActiva;
      var totalPaginas = Math.max(1, Math.ceil(totalCoincidencias / productosPorPagina));
      if (paginaFiltroActiva > totalPaginas) paginaFiltroActiva = totalPaginas;
      if (paginaFiltroActiva < 1) paginaFiltroActiva = 1;
      if (totalPaginas <= 1) {
        wrapper.hidden = true;
        return paginaFiltroActiva;
      }
      var html = '<nav class="pagination" role="navigation" aria-label="' + etiquetaNavegacion + '">'
        + '<ul class="pagination__list list-unstyled" role="list">';
      if (paginaFiltroActiva > 1) {
        html += '<li><a href="#" data-mt-pagina="' + (paginaFiltroActiva - 1) + '" '
          + 'class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce" '
          + 'aria-label="' + etiquetaAnterior + '"><span class="svg-wrapper">' + iconoFlechaHtml + '</span></a></li>';
      }
      for (var n = 1; n <= totalPaginas; n++) {
        if (n === paginaFiltroActiva) {
          html += '<li><a role="link" aria-disabled="true" '
            + 'class="pagination__item pagination__item--current light" aria-current="page">' + n + '</a></li>';
        } else {
          html += '<li><a href="#" data-mt-pagina="' + n + '" class="pagination__item link" '
            + 'aria-label="' + etiquetaPagina(n) + '">' + n + '</a></li>';
        }
      }
      if (paginaFiltroActiva < totalPaginas) {
        html += '<li><a href="#" data-mt-pagina="' + (paginaFiltroActiva + 1) + '" '
          + 'class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce" '
          + 'aria-label="' + etiquetaSiguiente + '"><span class="svg-wrapper">' + iconoFlechaHtml + '</span></a></li>';
      }
      html += '</ul></nav>';
      ignorarMutaciones = true;
      wrapper.innerHTML = html;
      wrapper.hidden = false;
      ignorarMutaciones = false;
      return paginaFiltroActiva;
    }

    // Se delega un único listener de clic (la paginación se reconstruye
    // entera en cada actualizarPaginacionFiltro(), así que un listener
    // puesto directamente en los enlaces se perdería en la siguiente
    // reconstrucción).
    document.addEventListener('click', function (e) {
      var enlace = e.target.closest('[data-mt-pagina]');
      if (!enlace) return;
      e.preventDefault();
      irAPaginaFiltro(parseInt(enlace.getAttribute('data-mt-pagina'), 10));
    });

    function filtrar() {
      moverMensajeVacio();
      var rejilla = rejillaActual();
      if (!rejilla) return;
      var consulta = normalizarTexto(input.value);
      var filtroActivo = hayFiltroActivo();

      if (!filtroActivo) {
        // Nada escrito ni ninguna categoría elegida: rejilla normal, tal
        // como la sirvió Shopify (las tarjetas traídas de otras páginas
        // se quedan ocultas), con SU paginación nativa.
        var visiblesSinFiltro = 0;
        rejilla.querySelectorAll('.grid__item').forEach(function (item) {
          var coincide = !item.hasAttribute('data-mt-buscar-extra');
          item.style.display = coincide ? '' : 'none';
          if (coincide) visiblesSinFiltro += 1;
        });
        var nativa = document.querySelector('.pagination-wrapper:not([data-mt-paginacion-filtro])');
        if (nativa) nativa.hidden = false;
        var propia = paginacionFiltroWrapper();
        if (propia) propia.hidden = true;
        if (vacioEl) vacioEl.hidden = visiblesSinFiltro !== 0;
        if (borrarBtn) borrarBtn.hidden = input.value === '';
        return;
      }

      // Primera vez que se activa un filtro: las tarjetas NATIVAS (las
      // que ya vinieron con esta página) también llevan la animación de
      // aparición "en cascada" de Dawn — a las traídas de otras páginas
      // ya se les quita (ver cargarExtras()), pero a estas no hacía
      // falta hasta ahora, porque de entrada se ven con su cascada
      // normal al cargar la página. En cuanto se empieza a filtrar, se
      // les quita también, para que ocultarlas/mostrarlas al cambiar de
      // categoría o buscar sea instantáneo, igual que a las demás — se
      // hace solo una vez (no en cada filtrar()) y no afecta al
      // MutationObserver de más abajo porque solo quita clases/atributos,
      // no mueve ni añade ni quita ninguna tarjeta de la rejilla.
      if (!nativasSinCascada) {
        rejilla.querySelectorAll('.grid__item:not([data-mt-buscar-extra])').forEach(function (item) {
          item.classList.remove('scroll-trigger', 'animate--slide-in');
          item.removeAttribute('data-cascade');
          item.style.removeProperty('--animation-order');
        });
        nativasSinCascada = true;
      }

      // Hay filtro: se oculta la paginación nativa (no sabe nada del
      // filtro) y se calcula primero CUÁLES coinciden, en el mismo orden
      // en que están en la rejilla (ese orden ya respeta el "Ordenar por"
      // actual, porque cargarExtras() trae cada página siguiente con la
      // misma URL/orden que la página 1).
      var nativaOculta = document.querySelector('.pagination-wrapper:not([data-mt-paginacion-filtro])');
      if (nativaOculta) nativaOculta.hidden = true;

      var coincidentes = [];
      rejilla.querySelectorAll('.grid__item').forEach(function (item) {
        var titulo = item.querySelector('.card__heading');
        var texto = normalizarTexto(titulo ? titulo.textContent : '');
        var tarjeta = item.querySelector('[data-mt-categoria]');
        var categoriaItem = tarjeta ? tarjeta.getAttribute('data-mt-categoria') : '';
        var coincideTexto = consulta === '' || texto.indexOf(consulta) !== -1;
        var coincideCategoria = categoriaActiva === '' || categoriaItem === categoriaActiva;
        if (coincideTexto && coincideCategoria) coincidentes.push(item);
      });

      var paginaAplicada = actualizarPaginacionFiltro(coincidentes.length);
      var inicio = (paginaAplicada - 1) * productosPorPagina;
      var fin = inicio + productosPorPagina;
      rejilla.querySelectorAll('.grid__item').forEach(function (item) { item.style.display = 'none'; });
      coincidentes.slice(inicio, fin).forEach(function (item) { item.style.display = ''; });

      if (vacioEl) vacioEl.hidden = coincidentes.length !== 0;
      if (borrarBtn) borrarBtn.hidden = input.value === '';
    }

    function reaplicarBusqueda() {
      // Las tarjetas "traídas de otra página" que hubiera antes ya no
      // existen (Shopify acaba de pintar la rejilla de cero) — si sigue
      // habiendo algo escrito o una categoría elegida, hay que volver a
      // traerlas antes de filtrar, si no el aviso de "sin resultados" y
      // los productos que se ven de verdad se quedan desincronizados.
      extrasListas = false;
      paginaFiltroActiva = 1;
      if (hayFiltroActivo()) {
        cargarExtras().then(filtrar);
      } else {
        filtrar();
      }
    }

    input.addEventListener('input', function () {
      paginaFiltroActiva = 1;
      if (hayFiltroActivo() && !extrasListas) {
        cargarExtras().then(filtrar);
      }
      filtrar();
    });

    if (borrarBtn) {
      borrarBtn.addEventListener('click', function () {
        input.value = '';
        paginaFiltroActiva = 1;
        filtrar();
        input.focus();
      });
    }

    // Píldoras de categoría (sections/mt-categorias.liquid). Solo una
    // activa a la vez: cada producto tiene una única categoría, así que
    // no hace falta selección múltiple. El botón "Todos" tiene
    // data-mt-categoria-boton="" (vacío).
    var botonesCategoria = document.querySelectorAll('[data-mt-categoria-boton]');
    botonesCategoria.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var valor = btn.getAttribute('data-mt-categoria-boton') || '';
        if (valor === categoriaActiva) return;
        categoriaActiva = valor;
        paginaFiltroActiva = 1;
        botonesCategoria.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        if (hayFiltroActivo() && !extrasListas) {
          cargarExtras().then(filtrar);
        } else {
          filtrar();
        }
      });
    });

    // Vigilar cuando Shopify vuelve a pintar la rejilla por su cuenta
    // (cambio de "Ordenar por" o de los filtros de "Filtrar:") para
    // reaplicar la búsqueda actual sobre el contenido nuevo. Se vigila
    // el envoltorio de la sección entera (más estable que la propia
    // rejilla, que es justo lo que Shopify reemplaza) para no perder de
    // vista los cambios aunque el elemento de la rejilla se sustituya
    // por uno nuevo.
    var contenedorVigilado = rejillaInicial.closest('[id^="shopify-section-"]') || rejillaInicial.parentElement;
    if (contenedorVigilado && window.MutationObserver) {
      var observador = new MutationObserver(function (mutaciones) {
        if (ignorarMutaciones) return;
        // OJO: MutationObserver entrega sus avisos de forma asíncrona (como
        // microtarea), así que cuando este callback se ejecuta,
        // "ignorarMutaciones" ya se ha vuelto a poner en false (se
        // restablece justo después, de forma síncrona, en cargarExtras()) —
        // el aviso de arriba casi nunca sirve de nada por el orden en el
        // que pasan las cosas. Por eso además se comprueba aquí, mirando
        // los nodos añadidos: si TODOS llevan la marca
        // "data-mt-buscar-extra" (son las tarjetas de otras páginas que
        // hemos colado nosotros mismos), son el propio aviso de "sin
        // resultados" (que moverMensajeVacio() reubica en el DOM, también
        // de forma síncrona pero detectada aquí de forma asíncrona), o
        // pertenecen al paginador propio de resultados filtrados (que se
        // crea y se reconstruye entero en cada filtrar()), no es un
        // repintado nuevo de Shopify, así que se ignora — si no, cada vez
        // que se traen esas tarjetas de otra página, se reubica el aviso
        // de "sin resultados", o se redibuja el paginador propio, se
        // volvería a disparar cargarExtras()/filtrar() sobre sí mismo.
        var esSoloNuestro = mutaciones.every(function (m) {
          return Array.prototype.every.call(m.addedNodes, function (n) {
            return n.nodeType !== 1
              || n.hasAttribute('data-mt-buscar-extra')
              || n === vacioEl
              || (wrapperPaginacionFiltro && wrapperPaginacionFiltro.contains(n));
          });
        });
        if (esSoloNuestro) return;
        reaplicarBusqueda();
      });
      observador.observe(contenedorVigilado, { childList: true, subtree: true });
    }
  }

  function initFaqAnalytics() {
    // Reservado: sin analítica externa por defecto.
  }

  // "Arma tu pack": selección múltiple de productos independientes con
  // descuento por cantidad. Al confirmar, añade cada producto como línea
  // de carrito normal (NO crea ningún producto "pack"). El descuento lo
  // aplica SOLO Shopify (son descuentos automáticos configurados en
  // Descuentos → sin código, por cantidad de artículos distintos) — aquí
  // solo se calcula qué % mostrar en el mensaje, no hace falta redirigir
  // a ningún código.
  function initArmaPack() {
    var wrap = document.querySelector('[data-mt-arma-pack]');
    if (!wrap) return;

    var descuentos;
    try { descuentos = JSON.parse(wrap.getAttribute('data-mt-arma-descuentos')); } catch (e) { descuentos = {}; }
    var redirectUrl = wrap.getAttribute('data-mt-arma-redirect') || '/cart';
    var tarjetas = wrap.querySelectorAll('[data-mt-arma-item]');
    var resumen = wrap.querySelector('[data-mt-arma-resumen]');
    var cuentaEl = wrap.querySelector('[data-mt-arma-cuenta]');
    var mensajeEl = wrap.querySelector('[data-mt-arma-mensaje]');
    var boton = wrap.querySelector('[data-mt-arma-boton]');
    var botonTodos = wrap.querySelector('[data-mt-arma-todos]');
    var seleccion = new Map(); // variantId -> { titulo, precio }

    // Textos ya traducidos (vienen del idioma de la página, ver
    // sections/mt-destacado-pack.liquid) — "999999" y "MT_PCT" son
    // marcadores de sobra que se sustituyen aquí por el número real.
    var textoUnoSeleccionado = wrap.getAttribute('data-mt-arma-texto-uno') || '';
    var textoVariosSeleccionados = wrap.getAttribute('data-mt-arma-texto-otros') || '';
    var plantillaMensajeDescuento = wrap.getAttribute('data-mt-arma-mensaje-descuento') || '';
    var mensajeAnadeMas = wrap.getAttribute('data-mt-arma-mensaje-mas') || '';

    function seleccionarCarta(card) {
      var variantId = card.getAttribute('data-mt-arma-variant');
      if (seleccion.has(variantId)) return;
      seleccion.set(variantId, {
        titulo: card.getAttribute('data-mt-arma-titulo'),
        precio: card.getAttribute('data-mt-arma-precio'),
      });
      card.classList.add('is-active');
    }

    function porcentajeParaCantidad(n) {
      var claves = Object.keys(descuentos).map(Number).sort(function (a, b) { return a - b; });
      var elegido = null;
      claves.forEach(function (umbral) { if (n >= umbral) elegido = descuentos[umbral]; });
      return elegido;
    }

    function actualizarResumen() {
      var n = seleccion.size;
      if (n === 0) { resumen.hidden = true; return; }
      resumen.hidden = false;
      cuentaEl.textContent = n === 1 ? textoUnoSeleccionado : textoVariosSeleccionados.replace('999999', n);
      var porcentaje = porcentajeParaCantidad(n);
      if (porcentaje) {
        mensajeEl.textContent = plantillaMensajeDescuento.replace('MT_PCT', Math.round(porcentaje * 100));
      } else {
        mensajeEl.textContent = mensajeAnadeMas;
      }
      boton.disabled = false;
    }

    tarjetas.forEach(function (card) {
      card.addEventListener('click', function () {
        var variantId = card.getAttribute('data-mt-arma-variant');
        if (seleccion.has(variantId)) {
          seleccion.delete(variantId);
          card.classList.remove('is-active');
        } else {
          seleccionarCarta(card);
        }
        actualizarResumen();
      });
    });

    // Solo "deseleccionar todos" — el botón vive dentro de la barra de
    // resumen, que ya está oculta cuando no hay nada elegido, así que no
    // hace falta ningún estado "seleccionar": si se ve, siempre vacía.
    if (botonTodos) {
      botonTodos.addEventListener('click', function () {
        seleccion.clear();
        tarjetas.forEach(function (card) { card.classList.remove('is-active'); });
        actualizarResumen();
      });
    }

    if (boton) {
      boton.addEventListener('click', function () {
        if (seleccion.size === 0) return;
        boton.disabled = true;
        var textoOriginal = boton.textContent;
        boton.textContent = 'Añadiendo…';

        var items = Array.from(seleccion.keys()).map(function (id) { return { id: id, quantity: 1 }; });

        // Ronda 141: igual que initEnvioFormularioProducto() (Ronda
        // 138) — antes esto llevaba SIEMPRE a redirectUrl (por
        // defecto, /cart), aunque hubiera barra lateral en la página;
        // el usuario pidió que, como el resto del carrito, abra la
        // barra en vez de navegar a ningún sitio.
        var drawer = document.querySelector('cart-drawer');
        var cuerpo = { items: items };
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          cuerpo.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
          cuerpo.sections_url = window.location.pathname;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(cuerpo),
        })
          .then(function (r) { return r.json(); })
          .then(function (respuesta) {
            // Ronda 145: una vez añadido de verdad al carrito, se
            // deselecciona todo — a petición del usuario. Antes, como
            // la página ya no navegaba a ningún sitio (Ronda 141), las
            // tarjetas se quedaban marcadas como elegidas aunque ya
            // estuvieran en el carrito, dando a entender que seguían
            // "pendientes" de añadir.
            seleccion.clear();
            tarjetas.forEach(function (card) { card.classList.remove('is-active'); });
            actualizarResumen();

            // Ronda 146: mismo aviso que initEnvioFormularioProducto() —
            // sin él, el regalo automático no se enteraba de que se
            // había añadido el Arnés desde aquí. Ver la nota completa
            // allí.
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mt-arma-pack', cartData: respuesta });
            }

            if (drawer && typeof drawer.renderContents === 'function' && respuesta.sections) {
              drawer.renderContents(respuesta);
              drawer.classList.remove('is-empty'); // ver nota Ronda 138/139
              drawer.open();
              boton.disabled = false;
              boton.textContent = textoOriginal;
            } else {
              window.location.href = redirectUrl;
            }
          })
          .catch(function () {
            boton.disabled = false;
            boton.textContent = textoOriginal;
          });
      });
    }
  }

  // Ficha de producto "pack" (mt-producto-pack): cada mini-galería (una por
  // artículo del pack) cambia de foto sola cuando se pulsa un color de SU
  // grupo de opción correspondiente, sin tocar la lógica de precio/variante
  // de initVariantes() (que sigue funcionando igual, son listeners aparte).
  function initPackGalerias() {
    document.querySelectorAll('[data-mt-pack-galeria]').forEach(function (galeria) {
      var opcionNombre = galeria.getAttribute('data-mt-pack-galeria');
      var img = galeria.querySelector('[data-mt-pack-imagen]');
      var dataEl = galeria.querySelector('[data-mt-pack-fotos]');
      if (!img || !dataEl || !opcionNombre) return;
      var fotos;
      try { fotos = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var grupo = document.querySelector('[data-mt-opcion="' + CSS.escape(opcionNombre) + '"]');
      if (!grupo) return;
      grupo.querySelectorAll('[data-mt-pill]').forEach(function (pill) {
        pill.addEventListener('click', function () {
          var valor = pill.getAttribute('data-mt-pill');
          if (fotos[valor]) img.src = fotos[valor];
        });
      });
    });
  }

  // La pasarela de productos (mt-productos) ya no usa JS: las tarjetas se
  // duplican en el propio Liquid y la anima una animación CSS (@keyframes
  // mt-productos-pasarela en mt-styles.css), así sigue funcionando aunque
  // la pestaña esté en segundo plano o el JS tarde en cargar.

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initProductoGaleria();
    initCantidad();
    initVariantes();
    initEnvioFormularioProducto();
    initPackGalerias();
    initArmaPack();
    initCodigoCarrito();
    initVaciarCarrito();
    initRegaloAutomatico();
    initSelectorColorRegalo();
    initBuscarProductos();
    initVolver();
    initFaqAnalytics();
  });
})();
